import axios from 'axios';

export default {
    name: 'review-pagination',

    emits: ['changePage'],

    props: {
        page: Number,
        totalNumResults: Number,
        filteredNumResults: Number,
        resultsPerPage: Number,
        resultsFiltered: Boolean
    },

    computed: {
        numPages() {
            if(this.resultsFiltered){
                return Math.ceil(this.filteredNumResults / this.resultsPerPage); 
            } else {
                return Math.ceil(this.totalNumResults / this.resultsPerPage);                
            }

        }
    },

    methods: {
        changePage(newPage) {
            this.$emit('changePage', newPage);
        }
    }
};
